<template>
  <form  class="pt-1">
    <!--begin::Heading-->
    <h3 class="fw-semibold text-dark mb-7">Advanced Search</h3>
    <!--end::Heading-->

    <!--begin::Input group-->
    <div class="mb-5">
      <input
        type="text"
        class="form-control form-control-sm form-control-solid"
        placeholder="Contains the word"
        name="query"
      />
    </div>
    <!--end::Input group-->

    <!--begin::Input group-->
    <div class="mb-5">
      <!--begin::Radio group-->
      <div class="nav-group nav-group-fluid">
        <!--begin::Option-->
        <label>
          <input
            type="radio"
            class="btn-check"
            name="type"
            value="has"
            checked
          />
          <span
            class="btn btn-sm btn-color-muted btn-active btn-active-primary"
          >
            All
          </span>
        </label>
        <!--end::Option-->

        <!--begin::Option-->
        <label>
          <input type="radio" class="btn-check" name="type" value="users" />
          <span
            class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4"
          >
            Users
          </span>
        </label>
        <!--end::Option-->

        <!--begin::Option-->
        <label>
          <input type="radio" class="btn-check" name="type" value="orders" />
          <span
            class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4"
          >
            Orders
          </span>
        </label>
        <!--end::Option-->

        <!--begin::Option-->
        <label>
          <input type="radio" class="btn-check" name="type" value="projects" />
          <span
            class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4"
          >
            Projects
          </span>
        </label>
        <!--end::Option-->
      </div>
      <!--end::Radio group-->
    </div>
    <!--end::Input group-->

    <!--begin::Input group-->
    <div class="mb-5">
      <input
        type="text"
        name="assignedto"
        class="form-control form-control-sm form-control-solid"
        placeholder="Assigned to"
        value=""
      />
    </div>
    <!--end::Input group-->

    <!--begin::Input group-->
    <div class="mb-5">
      <input
        type="text"
        name="collaborators"
        class="form-control form-control-sm form-control-solid"
        placeholder="Collaborators"
        value=""
      />
    </div>
    <!--end::Input group-->

    <!--begin::Input group-->
    <div class="mb-5">
      <!--begin::Radio group-->
      <div class="nav-group nav-group-fluid">
        <!--begin::Option-->
        <label>
          <input
            type="radio"
            class="btn-check"
            name="attachment"
            value="has"
            checked
          />
          <span
            class="btn btn-sm btn-color-muted btn-active btn-active-primary"
          >
            Has attachment
          </span>
        </label>
        <!--end::Option-->

        <!--begin::Option-->
        <label>
          <input type="radio" class="btn-check" name="attachment" value="any" />
          <span
            class="btn btn-sm btn-color-muted btn-active btn-active-primary px-4"
          >
            Any
          </span>
        </label>
        <!--end::Option-->
      </div>
      <!--end::Radio group-->
    </div>
    <!--end::Input group-->

    <!--begin::Input group-->
    <div class="mb-5">
      <select
        name="timezone"
        aria-label="Select a Timezone"
        data-control="select2"
        data-placeholder="date_period"
        class="form-select form-select-sm form-select-solid"
      >
        <option value="next">Within the next</option>
        <option value="last">Within the last</option>
        <option value="between">Between</option>
        <option value="on">On</option>
      </select>
    </div>
    <!--end::Input group-->

    <!--begin::Input group-->
    <div class="row mb-8">
      <!--begin::Col-->
      <div class="col-6">
        <input
          type="number"
          name="date_number"
          class="form-control form-control-sm form-control-solid"
          placeholder="Lenght"
          value=""
        />
      </div>
      <!--end::Col-->

      <!--begin::Col-->
      <div class="col-6">
        <select
          name="date_typer"
          aria-label="Select a Timezone"
          data-control="select2"
          data-placeholder="Period"
          class="form-select form-select-sm form-select-solid"
        >
          <option value="days">Days</option>
          <option value="weeks">Weeks</option>
          <option value="months">Months</option>
          <option value="years">Years</option>
        </select>
      </div>
      <!--end::Col-->
    </div>
    <!--end::Input group-->

    <!--begin::Actions-->
    <div class="d-flex justify-content-end">
      <button
       
        class="btn btn-sm btn-light fw-bold btn-active-light-primary me-2"
      >
        Cancel
      </button>

      <a href="#" class="btn btn-sm fw-bold btn-primary">Search</a>
    </div>
    <!--end::Actions-->
  </form>
</template>
